import React from 'react'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import { Link } from 'react-router-dom'

const Layout = ({ children }) => {
    return (
        <>
        <div className='bg-gray-100'>
            <div className='flex flex-auto'>
                <Sidebar />
                <div className='grow'>
                    <Navbar />
                    <div className='m-5'>{children}</div>
                    <footer  aria-labelledby="footer-heading">
                        <div className="mx-auto max-w-7xl px-6 pb-4">
                            <div className="border-t border-gray-300 pt-4">
                                <p className="text-xs text-center leading-5 text-gray-700">
                                    <span> &copy; Analidys 2024</span>
                                    <span> - Tous droits réservés  - </span>
                                    <span>
                                        <Link to="/cgu" className="hover:underline">
                                        Mentions légales
                                        </Link>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        </div>
        </>
    )
}

export default Layout
